import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Button from 'design-system/Button';
import { CardView, Spacer } from 'design-system';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { Tier } from 'features/premium/entities';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectTryFor0Text } from 'features/premium/selectors';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import { isWeb } from '../../../constants';
const UpgradeFeesCard = ({ regularMargins }) => {
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const userTier = useAppSelector(selectUserTier);
    const onUpgradePress = useCallback(() => {
        if (isWeb) {
            UpgradeWebModal.show(userTier === Tier.pro ? Tier.ultimate : Tier.pro);
            return;
        }
        navigation.navigateDeprecated('EmmaProModal', {
            tier: userTier === Tier.pro ? Tier.ultimate : Tier.pro,
            benefitId: 'aumFees',
        });
    }, [userTier]);
    const tryFor0Text = useAppSelector(selectTryFor0Text);
    if (userTier === Tier.ultimate)
        return null;
    return (<CardView noMarginBottom noMarginTop={regularMargins} style={regularMargins ? styles.regularMargins : null}>
      <View style={styles.container}>
        <Text Text-16>Upgrade for lower fees</Text>
        <Spacer h={4}/>
        <Text TextThin-14 Secondary>
          Move to a higher plan to unlock a lower AUM fee on your investments
        </Text>
        <Spacer h={12}/>
        <View style={styles.buttonContainer}>
          <Button square hug brandReversed title={tryFor0Text ?? 'Upgrade now'} onPress={onUpgradePress}/>
        </View>
      </View>
    </CardView>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        padding: rem(16),
    },
    buttonContainer: {
        alignSelf: 'flex-start',
    },
    regularMargins: {
        marginTop: rem(8),
        marginBottom: rem(8),
    },
}));
export default memo(UpgradeFeesCard);
